import { Component, OnInit, DoCheck } from "@angular/core";
import { StepperService } from "@core/stepper/stepper.service";
import { Router } from "@angular/router";
import { ShowHistoricalSearchService } from "@core/history/show-historical-search.service";
import { UserService } from "@core/user/user.service";
import { Observable } from "rxjs";
import { Role } from "@bl-enum/role";
import { AuthenticationService } from "@core/authentication/authentication.service";
import { Title, Meta } from "@angular/platform-browser";

@Component({
  selector: "bid-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, DoCheck {
  titleCenterButton: string;
  roluser;
  showHistoricalSearch: boolean;
  userLoged: boolean = false;
  activeNewAnalysis: boolean;
  observableIsAdmin$: Observable<boolean>;
  STEP0 = [
    { name: "generateNewAnalysis", stepSelected: false },
    { name: "afsReview", stepSelected: false, disabled: true },
    { name: "score", stepSelected: false, disabled: true },
    { name: "icrReview", stepSelected: false, disabled: true },
  ];
  STEP1 = [
    { name: "loadActionPlan", stepSelected: false },
    { name: "myActionPlan", stepSelected: false, disabled: false },
  ];
  constructor(
    private showHistoricalSearchService: ShowHistoricalSearchService,
    private stepperService: StepperService,
    private router: Router,
    private userService: UserService,
    private authService: AuthenticationService,
    private titleService : Title,
    private metaService : Meta
  ) {
    this.observableIsAdmin$ = this.userService.getIsAdminUser();
    this.metaService.addTag({name:'Content-Security-Policy', httpEquiv : 'Content-Security-Policy', content:"default-src 'self' https://luca2-dev.iadb.org/; object-src 'none'; base-uri 'none';require-trusted-types-for 'script'; report-uri https://luca2-dev.iadb.org;frame-ancestors 'self' https://luca2-dev.iadb.org;"});
    this.metaService.addTag({name:'X-Content-Security-Policy', httpEquiv : 'X-Content-Security-Policy', content:"default-src 'self' https://luca2-dev.iadb.org/; object-src 'none'; base-uri 'none';require-trusted-types-for 'script'; report-uri https://luca2-dev.iadb.org;frame-ancestors 'self' https://luca2-dev.iadb.org;"});
    this.metaService.addTag({name:'Strict-Transport-Security', httpEquiv : 'Strict-Transport-Security', content:"max-age=847200; includeSubDomains"});
  }
  ngOnInit() {
    this.showHistoricalSearch = false;
    this.showHistoricalSearchService.setShowHistoricalSearch(false);

    this.checkoutAccount();

    this.userService
      .getUserByMail(this.authService.msalService.getAccount().userName)
      .subscribe((res) => {
        if (res) {
          switch (res.role) {
            case Role.ADMIN:
              this.stepperService.setStepper(this.STEP0);
              this.userService.setIsAdminUser(true);
              this.activeNewAnalysis = true;
              this.roluser = Role.ADMIN;

              break;

            case Role.INVITED:
              this.stepperService.setStepper(this.STEP0);
              this.activeNewAnalysis = true;
              this.roluser = Role.INVITED;
              break;

            case Role.OEA:
              this.titleCenterButton = "Approve Action Plan";
              this.STEP1[0].disabled = true;
              this.STEP1[1].disabled = true;
              this.stepperService.setStepper(this.STEP1);
              this.roluser = Role.OEA;
              this.activeNewAnalysis = false;
              break;

            case Role.OEG:
              this.titleCenterButton = "Generate a new action plan";
              this.STEP1[0].disabled = true;
              this.STEP1[1].disabled = true;
              this.stepperService.setStepper(this.STEP1);
              this.roluser = Role.OEG;
              this.activeNewAnalysis = false;
              break;
          }
        }
        this.checkoutAccount();
      });
  }

  checkoutAccount() {
    this.userLoged = !!this.authService.msalService.getAccount();
  }

  ngDoCheck() {
    this.showHistoricalSearchService
      .getShowHistoricalSearch()
      .subscribe((res: any) => {
        this.showHistoricalSearch = res;
      });

    this.checkoutAccount();
  }
  redirectTo(): void {
    if (this.activeNewAnalysis == true) {
      this.redirectToGenerateaNewAnalysis();
    } else {
      this.redirectToLoadActionPlan();
    }
  }
  redirectToGenerateaNewAnalysis() {
    this.STEP0[0].stepSelected = true;
    this.stepperService.setStepper(this.STEP0);
    this.router.navigate(["/generate-new-analysis"]);
  }
  redirectToLoadActionPlan() {
    this.STEP1[0].stepSelected = true;
    this.stepperService.setStepper(this.STEP1);
    if (this.roluser == "OEG") this.router.navigate(["/load-action-plan"]);
    if (this.roluser == "OEA") this.router.navigate(["/ApproveActionPlan"]);
  }

  singIn() {
    if (!this.userLoged) {
      this.authService.login();
    } else {
      console.log("aaaa");

      this.authService.logout();
    }
  }
}
